module.exports = "https://trybtryb-legacy.web.app/img/support-me.054946b5.svg";